import axios from "axios";

const api = axios.create({
  baseURL: `https://api.ifjona.com/api`,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
  }
});

// Request interceptor for FormData
api.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;